import React from "react";
import { Box, Stack } from "@mui/material";
import TextTagInput2, { ITextTagInput2 } from "../../input/TextTagInput2";
import { TagModeType } from "../../../../types/filter.type";

type TagType = { value: string; mode: TagModeType; color: string };

interface IFilterTextTag2 extends Omit<ITextTagInput2, "onChange"> {
  placeholder?: string;
  pending?: boolean;
  onSearch?: (tags: TagType[] | string) => void;
}

function FilterTextTag2({
  label,
  defaultValue,
  placeholder,
  pending,
  toggleClear,
  onSearch,
}: IFilterTextTag2) {
  return (
    <Stack direction="row" gap={0.5}>
      <Box sx={{ flex: 1 }}>
        <TextTagInput2
          direction="column"
          label={label}
          labelWidth="25%"
          placeholder={placeholder}
          onChange={onSearch}
          pending={pending}
          toggleClear={toggleClear}
          defaultValue={defaultValue}
        />
      </Box>
    </Stack>
  );
}

export default FilterTextTag2;
